import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { loginUser } from "../../../services/api/userService.ts";
// Login Redux States
import { LOGIN_SUCCESS, LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods

function* logUser({ payload: { user, navigate } }) {
  try {
    const response = yield call(loginUser, user.email, user.password); // api axios login get user
    yield put(loginSuccess(response.res, navigate));
  } catch (error) {
    if (error?.response) {
    }
    // derive message from original Axios error or fallback
    let msg = "Erreur lors de la connexion";
    if (error?.response) {
      const resp = error.response.data;
      if (typeof resp === "string") {
        msg = resp;
      } else if (resp && resp.message) {
        msg = resp.message;
      } else if (resp && resp.errors && Array.isArray(resp.errors)) {
        msg = resp.errors.join(", ");
      } else {
        msg = JSON.stringify(resp);
      }
    } else if (error?.message) {
      msg = error.message;
    }
    yield put(apiError(msg));
  }
}

function* logSuccess({ payload: { data, navigate } }) {
  try {
    localStorage.setItem("token", JSON.stringify(data.accessToken));
    localStorage.setItem("authUser", JSON.stringify(data.user));
    /*if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const response = yield call(postJwtLogin, {
        email: user.email,
        password: user.password,
      });
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));*/
    navigate("/landing");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* logoutUser() {
  try {
    localStorage.removeItem("authUser");
    /*if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(LOGOUT_USER, response));
    } else {*/
    yield put(logoutUserSuccess(LOGOUT_USER, true));
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, logUser);
  yield takeEvery(LOGIN_SUCCESS, logSuccess);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
